import React from 'react';

const CircularLoaderCore = ({ lightStyle, spacing }) => (
    <div
        role="status"
        aria-label="Loading"
        className={
            'ch-icon-spinner ch-loader' +
            (lightStyle ? ' ch-loader-spinner-light' : '') +
            (spacing ? ' ch-loader-spacing' : '')
        }
    >
        <svg aria-hidden="true" width="24px" height="24px" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" strokeWidth="10" fill="none"
                    strokeLinecap="round" strokeDasharray="170, 90" />
        </svg>
        <span className="ch-sr-only">Loading</span>
    </div>
);

const CircularLoader = props => {
    const {visible = true, lightStyle = false, pageCentered = true, displayInElement = false, displayInline = false, spacing = false, coreOnly = false} = props;

    if (!visible) {
        return null;
    }
    if (coreOnly) {
        return <CircularLoaderCore/>
    }
    if (pageCentered) {
        return (
            <div className={displayInElement ? 'ch-loader-centered-in-element' : 'ch-loader-centered'}>
                <CircularLoaderCore/>
            </div>
        )
    }

    if(displayInline) {
        return (
            <div className={'ch-loader-inline'}>
                <CircularLoaderCore/>
            </div>
        )
    }
    return <CircularLoaderCore spacing={spacing} lightStyle={lightStyle} />
};

export default CircularLoader;